import { jsx as o, jsxs as d } from "react/jsx-runtime";
import { memo as m, useCallback as L, Fragment as y, cloneElement as T } from "react";
import { useTheme as b, useMediaQuery as g, Drawer as P, Divider as v, ClickAwayListener as w } from "@mui/material";
import "./_root.mjs";
import "./_baseGetTag.mjs";
import { useToggle as E } from "./useToggle.mjs";
import { TEST_IDS as M } from "./testIds.mjs";
import { MOBILE_SCREEN as f } from "./screens.mjs";
import { Tooltip as k, Header as H, CloseButton as O, Description as R, Footer as x } from "./styles38.mjs";
import { Typography as C } from "./index59.mjs";
const B = m(
  ({ testId: e, children: t, ...r }) => /* @__PURE__ */ o(
    k,
    {
      disableFocusListener: !0,
      disableTouchListener: !0,
      "data-testid": e,
      ...r,
      children: t
    }
  )
), D = {
  disablePortal: !0
}, F = m(
  ({
    testId: e,
    children: t,
    mobileDescription: r,
    mobileFooter: l,
    hideTitle: p = !1,
    ...c
  }) => {
    const [i, s] = E(), a = b(), u = g(a.breakpoints.down(f)), n = () => {
      s(!1);
    }, h = L(() => {
      s();
    }, [s]);
    return u ? /* @__PURE__ */ d(y, { children: [
      T(t, {
        ...t.props,
        onClick: h
      }),
      /* @__PURE__ */ d(
        P,
        {
          anchor: "bottom",
          open: i,
          onClose: n,
          PaperProps: S(a),
          children: [
            /* @__PURE__ */ d(H, { $hideTitle: p, children: [
              !p && /* @__PURE__ */ o(C.H6, { children: c.title }),
              /* @__PURE__ */ o(O, { onClick: n })
            ] }),
            /* @__PURE__ */ o(v, {}),
            r && /* @__PURE__ */ o(R, { children: /* @__PURE__ */ o(C.Body1, { children: r }) }),
            l && /* @__PURE__ */ o(x, { onClick: n, children: l })
          ]
        }
      )
    ] }, "bottom") : /* @__PURE__ */ o(w, { onClickAway: n, children: /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(
      k,
      {
        PopperProps: D,
        onClose: n,
        open: i,
        disableFocusListener: !0,
        disableHoverListener: !0,
        disableTouchListener: !0,
        "data-testid": e,
        ...c,
        children: T(t, {
          ...t.props,
          onClick: h
        })
      }
    ) }) });
  }
), G = m(
  ({
    testId: e = M.tooltip,
    trigger: t = "hover",
    placement: r = "top",
    mobileFooter: l,
    mobileDescription: p,
    hideTitle: c,
    ...i
  }) => {
    const s = b(), a = g(s.breakpoints.down(f));
    return t === "click" || a ? /* @__PURE__ */ o(
      F,
      {
        "data-testid": e,
        placement: r,
        mobileFooter: l,
        mobileDescription: p,
        hideTitle: c,
        ...i
      }
    ) : /* @__PURE__ */ o(B, { "data-testid": e, placement: r, ...i });
  }
), S = (e) => ({
  style: {
    borderTopLeftRadius: e.spacing(3),
    borderTopRightRadius: e.spacing(3)
  }
});
export {
  G as Tooltip
};
//# sourceMappingURL=index58.mjs.map
